import { render, staticRenderFns } from "./PresetGallery.html?vue&type=template&id=020ed1c2&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./PresetGallery.scss?vue&type=style&index=0&id=020ed1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ed1c2",
  null
  
)

export default component.exports